export default "/images/vendor/flag-icons/flags/4x3/zw.svg?27efe68ca96d31dc7eebdf85e75b1f71";